import { Injectable } from '@angular/core';
import { formatMessage } from 'devextreme/localization';
import packageInfo from '../../../../../package.json';

@Injectable()
export class AppInfoService {
  constructor() {}

  get title(): string {
    return formatMessage('title');
  }

  get currentYear(): number {
    return new Date().getFullYear();
  }

  get appVersion(): string {
    return packageInfo.version;
  }
}
